import { applyParamsToBlockContent } from '@/lib/api/strapi/strapi.utils'
import { BlocksContent, BlocksRenderer } from '@strapi/blocks-react-renderer'
import { forwardRef } from 'react'

interface RichTextProps {
  className?: string
  content?: BlocksContent | null
  params?: Record<string, string>
}

const RichText = forwardRef<HTMLDivElement, RichTextProps>(
  ({ content, params, className }, ref) => {
    if (!content) return null

    return (
      <div ref={ref} className={className}>
        <BlocksRenderer content={applyParamsToBlockContent(content, params)} />
      </div>
    )
  },
)

RichText.displayName = 'RichText'

export default RichText
